import { Box, Grid } from "@mui/material";
import { MULTI_SELECT_INPUT_TYPES } from "../../../constants";

const SurveyMultipleChoices = ({ selections, question, selectChoice, themeColors }) => {
    function handleSelectChoice(choice, questionId) {
        if (selectChoice) {
            selectChoice(choice, questionId);
        }
    }

    return (
        <Grid container spacing={2} alignItems="stretch">
            {question.choices.map((choice, i) => (
                <Grid
                    item
                    sm={question.choices.length > 10 ? 6 : 12}
                    lg={question.choices.length > 10 ? 4 : 6}
                    key={i}
                    className="cursor-pointer select-none w-full"
                >
                    <Box
                        className="w-full border border-slate-300 h-full px-[30px] py-[14px] md:px-[24px] md:py-[24px] rounded-xl font-medium relative text-[#5E718D] flex gap-2"
                        onClick={() => handleSelectChoice(choice, question.id)}
                        style={{
                            // Change the background color if a radio option is selected
                            backgroundColor:
                                choice.inputType === MULTI_SELECT_INPUT_TYPES.radio &&
                                selections &&
                                !!Object.values(selections[question.id] || {}).find((ch) => ch.id === choice.id)
                                    ? themeColors.primaryColor + "20"
                                    : "transparent",
                        }}
                    >
                        <div className="flex md:block items-center md:items-start md:top-[15px] inset-y-0 left-[7px] md:left-[10px] mb-auto">
                            {/* Add a checkbox if it's a checkbox question */}
                            {choice.inputType === MULTI_SELECT_INPUT_TYPES.checkbox && (
                                <input
                                    aria-label={choice.label}
                                    type="checkbox"
                                    value=""
                                    readOnly={true}
                                    checked={
                                        selections &&
                                        !!Object.values(selections[question.id] || {}).find((ch) => ch.id === choice.id)
                                    }
                                    className="accent-[#EFF2EE] w-[11.59px] h-[11.59px] md:w-4 md:h-4 checkbox-default border-none "
                                />
                            )}
                        </div>
                        <span className="md:text-base text-[11.14px] relative top-[-3px]">{choice.label}</span>
                    </Box>
                </Grid>
            ))}
        </Grid>
    );
};

export default SurveyMultipleChoices;
